export const save = <T>(key: string, value: T) => {
	try {
		sessionStorage.setItem(key, JSON.stringify(value));
	} catch (error) {
		console.log('🚀 ~ file: localstorage.util.ts:5 ~ save ~ error:', error);
	}
};

export const get = <T>(key: string) => {
	try {
		return JSON.parse(sessionStorage.getItem(key)) as T;
	} catch (error) {
		console.log('🚀 ~ file: localstorage.util.ts:13 ~ get ~ error:', error);
		return null;
	}
};

export const remove = (key: string) => {
	localStorage.removeItem(key);
};
